import Api from "./Api"
import { API_VERSION } from "@/config/index"

export default {
    GetCurrency(payload) {
        return Api().get(`/admin/currency`)
        // return Api().get(`/${API_VERSION}/admin/cinemas`)
    },
    GetRoles(payload) {
        return Api().get(`/admin/role`);
    },
    GetCities() {
        return Api().get(`/admin/cities`);
    },
    GetCountries() {
        return Api().get(`/admin/countries`);
    },
    GetPaymentOptions() {
      return Api().get(`/admin/payment-options`);
    },
    resendTransctionMail(payload) {
        console.log(payload.transction_id, "payload >>>>>>>>>>>>>>>>>>>>")
      return Api().get(`/admin/resend-email/${payload.transction_id}`);
    },
    ViewTicketHtml(payload) {
        console.log(payload, "payload >>>>>>>>>>>>>>>>>>>>")
      return Api().get(`/admin/view-ticket/${payload.transction_id}?transaction_currency=${payload.transaction_currency}`);
    },
    DownloadTicketHtml(payload) {
      console.log(payload, "payload >>>>>>>>>>>>>>>>>>>>")
    return Api().post(`/admin/download-ticket/${payload.transaction_id}`, payload);
    },
}


